import React, { useState } from 'react';
import { Avatar, IconButton, Menu, MenuItem, ListItemIcon } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import CampaignIcon from '@mui/icons-material/Campaign';
import SettingsIcon from '@mui/icons-material/Settings';
import SilentMentorSettingsDialog from './SilentMentorSettingsDialog';
import AdminNotificationDialog from './AdminNotificationDialog';
import { useNavigate } from 'react-router-dom';

export default function ProfileMenu({ onLogout, onTrackProgress, user }) {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [adminNotifyOpen, setAdminNotifyOpen] = useState(false);
  const open = Boolean(anchorEl);

  const isAdmin = user?.role === 'admin';

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton onClick={handleMenu} size="large" sx={{ ml: 1 }}>
        <Avatar sx={{ bgcolor: isAdmin ? 'secondary.main' : 'primary.main' }}>
          <PersonIcon />
        </Avatar>
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose} onClick={handleClose}>
        <MenuItem onClick={onTrackProgress}>
          <ListItemIcon><TrackChangesIcon fontSize="small" /></ListItemIcon>
          Track Progress
        </MenuItem>
        {isAdmin && (
          <>
            <MenuItem onClick={() => { setAdminNotifyOpen(true); }}>
              <ListItemIcon><CampaignIcon fontSize="small" /></ListItemIcon>
              Send Notifications
            </MenuItem>
            <MenuItem onClick={() => { /* close menu then navigate */ navigate('/admin/import'); }}>
              <ListItemIcon><SettingsIcon fontSize="small" /></ListItemIcon>
              Import Papers
            </MenuItem>
            <MenuItem onClick={() => { navigate('/admin/import-config'); }}>
              <ListItemIcon><SettingsIcon fontSize="small" /></ListItemIcon>
              Import Config
            </MenuItem>
            <MenuItem onClick={() => { navigate('/admin/support-tickets'); }}>
              <ListItemIcon><CampaignIcon fontSize="small" /></ListItemIcon>
              Support Tickets
            </MenuItem>
            <MenuItem onClick={() => { navigate('/admin/ads-summary'); }}>
              <ListItemIcon><CampaignIcon fontSize="small" /></ListItemIcon>
              Ad Reports
            </MenuItem>
          </>
        )}
        <MenuItem onClick={() => setSettingsOpen(true)}>
          <ListItemIcon><SettingsIcon fontSize="small" /></ListItemIcon>
          Silent Mentor Settings
        </MenuItem>
        <MenuItem onClick={onLogout}>
          <ListItemIcon><LogoutIcon fontSize="small" /></ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
      <SilentMentorSettingsDialog open={settingsOpen} onClose={() => setSettingsOpen(false)} />
      <AdminNotificationDialog open={adminNotifyOpen} onClose={() => setAdminNotifyOpen(false)} />
    </>
  );
}
